/**
 * Format a number as BDT (Bangladeshi Taka) amount using lakhs/crores style (e.g. 12,34,567.00).
 * @param {number|string|null|undefined} value - The amount to format
 * @param {Object} options - Optional: { decimals: number, prefix: string }
 * @returns {string} Formatted amount e.g. "12,34,567.00"
 */
export function formatBdt(value, options = {}) {
  const { decimals = 2, prefix = '' } = options;
  let input = value;
  if (!input && input !== 0) {
    return '';
  }
  input = Number(input);
  if (Number.isNaN(input)) {
    return '';
  }
  let isNegative = false;
  if (input < 0) {
    isNegative = true;
    input = input * -1;
  }
  input = Number(input).toFixed(decimals);
  const s = input.split('.');
  let intPart = s[0];
  const lastThree = intPart.substring(intPart.length - 3);
  const otherNumbers = intPart.substring(0, intPart.length - 3);
  const lastPart = otherNumbers !== '' ? ',' + lastThree : lastThree;
  const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastPart + '.' + (s[1] || '00');
  const result = isNegative ? '-' + formatted : formatted;
  return prefix ? `${prefix} ${result}` : result;
}
